import React from "react";

const SvgMarkerStar = ({ svgRef, title, ...props }) => (
  <svg viewBox="0 0 15 22" ref={svgRef} { ...{ ...{width: "1em", height: "1em"}, ...props } }>
    <title>{title}</title>
    <defs>
      <path
        id="MarkerStar_svg__a"
        d="M1240.746 256.998c-1.804-3.576-6.186-5.026-9.762-3.222-3.576 1.804-4.994 6.315-3.222 9.762 1.74 3.448 5.541 10.858 5.541 10.858a1.05 1.05 0 0 0 1.902 0s4.51-8.796 5.54-10.858c1.032-2.062 1.064-4.414 0-6.54zm-3.491 7.688l-2.99-1.804-2.989 1.804.794-3.4-2.641-2.288 3.478-.295 1.359-3.207 1.359 3.207 3.478.295-2.641 2.287z"
      />
    </defs>
    <use
      fill="currentColor"
      xlinkHref="#MarkerStar_svg__a"
      transform="translate(-1227 -253)"
    />
  </svg>
);

const ForwardRef = React.forwardRef((props, ref) => (
  <SvgMarkerStar svgRef={ref} {...props} />
));
export default ForwardRef;



// WEBPACK FOOTER //
// ./src/common/icons/MarkerStar.js